import { Button, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import { billingCurrentApi, logOutApi } from "../../config/Api";
import { apiErrorMessage } from "../../services/ApiError";
import { logOut } from "../../services/LogOut";
import { setStoredActivePlan } from "../../services/Plan";
import { PendingPayments } from "./PendingPayments";
import { PlanOptions } from "./PlanOptions";
import { useFreePlan } from "./useFreePlan";

// shown instead of the app to a doctor without an active plan (none chosen yet, or expired)
export const ChoosePlan = () => {
    const [current, setCurrent] = useState(null)

    // the app opens once there is an active plan
    const openApp = () => {
        setStoredActivePlan(true)
        window.location.assign('/')
    }

    const loadCurrent = () => {
        billingCurrentApi()
            .then((res) => {
                // a plan that became active elsewhere (or an old session without the flag) goes straight in
                if (res.data.data.has_active_plan) {
                    openApp()
                    return
                }
                setCurrent(res.data.data)
            })
            .catch((err) => notification.error({ message: apiErrorMessage(err) }))
    }

    useEffect(() => {
        loadCurrent()
    }, [])

    const { chooseFree, saving, modal } = useFreePlan(openApp)

    const onLogout = () => {
        logOutApi().finally(() => logOut())
    }

    const heading = current?.expired
        ? `Your ${current.plan?.name} plan ended on ${moment(current.ends_at).format('DD MMM YYYY')}`
        : 'Choose your plan'

    return (
        <div className="ChoosePlan" style={{ minHeight: '100vh', background: '#f5f6f8', padding: '32px 16px' }}>
            <div style={{ maxWidth: 1100, margin: '0 auto' }}>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h2 className="mb-0">Nutri Nexus</h2>
                    <Button type="link" onClick={onLogout}>Logout</Button>
                </div>
                <Spin spinning={!current}>
                    <h3 className="mt-3 mb-1">{heading}</h3>
                    <p className="text-muted">
                        {current?.expired
                            ? 'Renew it or choose another plan to continue using Nutri Nexus.'
                            : 'Pick a plan to start using Nutri Nexus. You can upgrade any time.'}
                    </p>
                    <PendingPayments payments={current?.pending_payments} onPaid={openApp} />
                    {current && (
                        <PlanOptions
                            current={current}
                            onFree={() => chooseFree()}
                            freeLoading={saving}
                            onPaid={openApp}
                            onPending={loadCurrent}
                        />
                    )}
                </Spin>
            </div>

            {modal}
        </div>
    )
}
